import React, { useState } from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { FaHome, FaUserFriends, FaToilet, FaBed } from 'react-icons/fa';
import { IconRule } from '../../components';
import { selectableIcons } from '../../util/selectableIcons';
import css from './ListingPage.module.css';
import { PrimaryButton } from '../../components';

const MAX_ITEMS = 4;

const SectionAmenities = props => {
  const intl = useIntl();
  const { publicData } = props;
  const [showMore, setShowMore] = useState(false);

  const propertyType = publicData.property_type;
  const guestCapacity = publicData.guest_capacity;
  const rooms = publicData.number_rooms;
  const beds = publicData.number_beds;
  const bathrooms = publicData.number_bathrooms / 2;
  const surface = publicData.surface / 100;
  const amenities = publicData?.amenities || [];

  const visibleAmenities = showMore ? amenities : amenities.slice(0, MAX_ITEMS);

  const getIconComponent = iconId => {
    const iconConfig = selectableIcons.find(icon => icon.id === iconId);
    return iconConfig?.icon || null;
  };

  const getAmenityLabel = iconId => {
    const iconConfig = selectableIcons.find(icon => icon.id === iconId);

    if (iconConfig?.description) return iconConfig.description;

    return String(iconId)
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase());
  };

  const normalizedAmenities = visibleAmenities.map(a => {
    if (a && typeof a === 'object') {
      const iconId = a.iconId || a.option || a.id;
      const label = a.label || getAmenityLabel(iconId);
      return { ...a, iconId, label };
    }

    const iconId = a;
    return { iconId, label: getAmenityLabel(iconId) };
  });

  const onToggleShowMore = () => {
    setShowMore(prev => !prev);
  };

  const shouldShowButton = amenities.length > MAX_ITEMS;

  return (
    <section className={css.sectionAmenitiesContainer}>
      <h2 className={`${css.heading} ${css.customAdviceheading}`}>
        <FormattedMessage id="SectionAmenities.heading" />
      </h2>

      <ul className={css.amenitiesContainer}>
        <li className={css.amenityItem}>
          <FaHome />
          <p>{propertyType}</p>
        </li>

        <li className={css.amenityItem}>
          <FaBed />
          <p>{intl.formatMessage({ id: 'SectionAmenities.roomsInfo' }, { rooms })}</p>
        </li>

        <li className={css.amenityItem}>
          <FaUserFriends />
          <p>
            {intl.formatMessage({ id: 'SectionAmenities.guestCapacityInfo' }, { guestCapacity })}
          </p>
        </li>

        <li className={css.amenityItem}>
          <FaBed />
          <p>{intl.formatMessage({ id: 'SectionAmenities.bedsInfo' }, { beds })}</p>
        </li>

        <li className={css.amenityItem}>
          <FaToilet />
          <p>{intl.formatMessage({ id: 'SectionAmenities.bathRoomsInfo' }, { bathrooms })}</p>
        </li>

        <li className={css.amenityItem}>
          <IconRule />
          <p>{intl.formatMessage({ id: 'SectionAmenities.surfaceInfo' }, { surface })}</p>
        </li>

        {normalizedAmenities.map((amenity, index) => {
          const IconComponent = getIconComponent(amenity.iconId);

          if (!IconComponent) return null;

          return (
            <li key={`${amenity.iconId}-${index}`} className={css.amenityItem}>
              <IconComponent />
              <p>{amenity.label}</p>
            </li>
          );
        })}
      </ul>

      {shouldShowButton ? (
        <PrimaryButton className={css.SectionAmenitiesButton} onClick={onToggleShowMore}>
          {showMore ? (
            <FormattedMessage id="SectionAmenities.showLess" />
          ) : (
            <FormattedMessage id="SectionAmenities.showMore" />
          )}
        </PrimaryButton>
      ) : null}
    </section>
  );
};

export default SectionAmenities;
